import { Alert, Box, Typography } from "@mui/material";

/**
 * Stands in for a screen that has not been built yet, so authority gating,
 * the sidebar and the navigation specs are exercisable end to end.
 */
export function Placeholder({ title, phase }: { title: string; phase: string }) {
  return (
    <Box>
      <Typography variant="h5" component="h2" gutterBottom>
        {title}
      </Typography>
      <Alert severity="info">Not built yet — scheduled for {phase}.</Alert>
    </Box>
  );
}
